var App = App || {};

App.BlogPostRelated = (function ($) {
    "use strict";

    function init() {

        const blogpostRelated = $(".block-blog-post-related");
        if (blogpostRelated.length) {
            blogpostRelated.each(function () {
                InitCarousels($(this));
            });
        }
    }

    function InitCarousels(blogpostRelated) {
        const carousel = blogpostRelated.find(".splide");

        if (carousel.length) {
            const splideCarousel = new Splide(carousel[0], {
                pagination: false,
                type: 'loop',
                fixedWidth: "325px",
                gap: "30px",
                drag: true,
                snap: false,
                perMove: 1,
                breakpoints: {
                    991: {
                        fixedWidth: "260px",
                        gap: "10px",
                    },
                }
            });

            splideCarousel.mount();

            const nextBtn = blogpostRelated.find(".carousel-btn.carousel-next");
            const prevBtn = blogpostRelated.find(".carousel-btn.carousel-prev");

            nextBtn.on("click", function () {
                splideCarousel.go('+1');
            });

            prevBtn.on("click", function () {
                splideCarousel.go('-1');
            });
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.BlogPostRelated.init();
});